<app-navbar>
  <app-user-action></app-user-action>
</app-navbar>
<div class="page-layout">
  <app-sidebar></app-sidebar>
  <div class="main-content">
    <div class="ui container on-air-container">
      @if (onAirItemList) {
        <div class="ui six doubling cards">
          @for (item of onAirItemList; track item) {
            <div class="card item-card">
              <a class="image" [routerLink]="['item', item.id]">
                @if (item.coverImage) {
                  <ui-responsive-image [src]="item.coverImage.url"
                               [size]="{
                                      width: '100%',
                                      ratio: 1.405152224824,
                                      originalWidth: item.coverImage.width,
                                      originalHeight: item.coverImage.height}"
                  [background]="item.coverImage.dormantColor"></ui-responsive-image>
                }
              </a>
              <a class="content" [routerLink]="['/item', item.id]">
                <span>{{item.nameCn || item.name || ' '}}</span>
              </a>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
